module.exports = __webpack_public_path__ + "img/0Q3B1621-26_H_L_BlackMatted_MockedUp.61422964.jpg";